import { createAction, props } from '@ngrx/store';
import { PupilAttendanceSchedule, SchoolCalendarException } from '@core/models/domain/school-calendar.domain';
import {
  SchoolCalendarExceptionRequest,
  SetPupilAttendanceScheduleRequest
} from '@core/models/request/school-calendar.request';

// EXCEPTIONS
export const loadExceptions = createAction(
  '[SchoolCalendar] Load Exceptions',
  props<{ from?: string; to?: string }>()
);
export const loadExceptionsSuccess = createAction(
  '[SchoolCalendar] Load Exceptions Success',
  props<{ exceptions: SchoolCalendarException[] }>()
);
export const loadExceptionsFailure = createAction(
  '[SchoolCalendar] Load Exceptions Failure',
  props<{ error: any }>()
);

export const saveException = createAction(
  '[SchoolCalendar] Save Exception',
  props<{ request: SchoolCalendarExceptionRequest }>()
);
export const saveExceptionSuccess = createAction('[SchoolCalendar] Save Exception Success');
export const saveExceptionFailure = createAction(
  '[SchoolCalendar] Save Exception Failure',
  props<{ request?: SchoolCalendarExceptionRequest; error: any }>()
);

export const cancelException = createAction(
  '[SchoolCalendar] Cancel Exception',
  props<{ exceptionId: string }>()
);
export const cancelExceptionSuccess = createAction(
  '[SchoolCalendar] Cancel Exception Success',
  props<{ exceptionId: string }>()
);
export const cancelExceptionFailure = createAction(
  '[SchoolCalendar] Cancel Exception Failure',
  props<{ exceptionId: string; error: any }>()
);

// PART-TIME PUPIL TIMETABLES
export const loadSchedules = createAction('[SchoolCalendar] Load Schedules');
export const loadSchedulesSuccess = createAction(
  '[SchoolCalendar] Load Schedules Success',
  props<{ schedules: PupilAttendanceSchedule[] }>()
);
export const loadSchedulesFailure = createAction(
  '[SchoolCalendar] Load Schedules Failure',
  props<{ error: any }>()
);

export const saveSchedule = createAction(
  '[SchoolCalendar] Save Schedule',
  props<{ request: SetPupilAttendanceScheduleRequest }>()
);
export const saveScheduleSuccess = createAction('[SchoolCalendar] Save Schedule Success');
export const saveScheduleFailure = createAction(
  '[SchoolCalendar] Save Schedule Failure',
  props<{ error: any }>()
);

export const removeSchedule = createAction(
  '[SchoolCalendar] Remove Schedule',
  props<{ pupilAccountId: string }>()
);
export const removeScheduleSuccess = createAction('[SchoolCalendar] Remove Schedule Success');
export const removeScheduleFailure = createAction(
  '[SchoolCalendar] Remove Schedule Failure',
  props<{ error: any }>()
);
